import React from "react";

import { Switch } from "@/components/ui/switch";
import { SmtpAccountsTableActions } from "routes/smtp_accounts/SmtpAccountsTableActions";

export const getSmtpAccountsTableColumns = ({ handleSetAsDefault }) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Username",
      id: "Username",
      accessorKey: "username",
    },
    {
      header: "Server",
      id: "Server",
      accessorKey: "server",
    },
    {
      header: "Port",
      id: "Port",
      accessorKey: "port",
    },
    {
      header: "Encryption",
      id: "Encryption",
      accessorKey: "encryption",
      cell: ({ row }) =>
        row.original?.encryption === "starttls" ? "STARTTLS" : "SSL/TLS",
    },
    {
      header: "Set as Default",
      id: "Set as Default",
      size: 100,
      enableSorting: false,
      cell: ({ row }) => (
        <Switch
          name={`is_default_${row.original?.id}`}
          checked={row.original?.is_default}
          onCheckedChange={checked =>
            handleSetAsDefault(row.original?.id, checked)
          }
          aria-label="Set as default"
        />
      ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <SmtpAccountsTableActions original={row.original} />,
    },
  ];
};
